<script setup>
import { useCalendar, useDayjs } from '@daysmart/daysmart-vue-components/composables'
import { useCalendarSettings } from '../composables/useCalendarSettings'

const props = defineProps({
  date: {
    type: String,
    required: true,
  },
})

const dayjs = useDayjs()
const { customFirstDayOfWeek } = useCalendarSettings()
const calendar = useCalendar({ customFirstDayOfWeek })

const daysOfWeek = computed(() => calendar.getWeekView.value(props.date))
const todaysDate = computed(() => dayjs.value().format('YYYY-MM-DD'))

function isToday(day) {
  return day.format('YYYY-MM-DD') === `${todaysDate.value}`
}
</script>

<template>
  <div class="m-2 mt-0 h-44px min-w-470px flex lt-sm:!hidden">
    <template
      v-for="day of daysOfWeek"
      :key="day"
    >
      <div
        class="flex flex-1 items-center justify-center whitespace-nowrap px-4 py-3 text-text-500"
        :class="{ 'bg-secondary rounded-8px': isToday(day) }"
      >
        <span
          class="mr-1 text-sm font-semibold"
          :class="{ 'text-text-100': isToday(day) }"
        >{{ day.format('ddd') }}</span>
        <span
          class="text-sm font-semibold"
          :class="{ 'text-text-100': isToday(day) }"
        >{{ day.format('D') }}</span>
      </div>
    </template>
  </div>
</template>
